module.exports = __webpack_public_path__ + "img/parallax-light-blue.0d2c5672.jpg";